import { render, staticRenderFns } from "./DraggableListsNested.vue?vue&type=template&id=7f5dd0d7&scoped=true&"
import script from "./DraggableListsNested.vue?vue&type=script&lang=js&"
export * from "./DraggableListsNested.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsNested.vue?vue&type=style&index=0&id=7f5dd0d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dd0d7",
  null
  
)

export default component.exports